import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import {
  NzFormControlComponent,
  NzFormItemComponent,
  NzFormLabelComponent,
  NzFormModule,
} from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FilterData } from '../../admin-strategy';

@Component({
  selector: 'app-strategy-details',
  standalone: true,
  imports: [
    NzFormModule,
    NzFormLabelComponent,
    NzFormControlComponent,
    NzFormItemComponent,
    NzInputModule,
    NzSelectModule,
    NzRadioModule,
    NzCheckboxModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  templateUrl: './strategy-details.component.html',
  styleUrl: './strategy-details.component.scss',
})
export class StrategyDetailsComponent {
  @Input() languageLevel: FilterData[] = [];
  @Input() behaviourResuorceType: FilterData[] = [];
  @Input() behaviourReplacementType: FilterData[] = [];
  @Input() behaviourSupervisionType: FilterData[] = [];

  @Input() detailsForm!: FormGroup;

  readonly maxTitleLength = 100;
  readonly maxDescriptionLength = 4000;

  getCharacterCount(controlName: string): string {
    const control = this.detailsForm.get(controlName);
    const currentLength = control?.value?.length || 0;
    return `${currentLength} of ${this.maxDescriptionLength} characters remaining`;
  }

  getError(controlName: string): string {
    const control = this.detailsForm.get(controlName);
    if (!control?.errors || (!control.dirty && !control.touched)) return '';

    const errorMessages: {
      [key in
        | 'resourceType'
        | 'replacementType'
        | 'title'
        | 'description'
        | 'languageLevel'
        | 'supervisionType']: string;
    } = {
      resourceType: 'Please select a resource type',
      replacementType: 'Please select at least one replacement type',
      title: control.errors['maxlength']
        ? `Title cannot exceed ${this.maxTitleLength} characters`
        : 'Title is required',
      description: control.errors['maxlength']
        ? `Description cannot exceed ${this.maxDescriptionLength} characters`
        : 'Description is required',
      languageLevel: 'Please select a language level',
      supervisionType: 'Please select a supervision type',
    };

    return (
      errorMessages[controlName as keyof typeof errorMessages] ||
      'Invalid input'
    );
  }

  isInvalid(controlName: string): boolean {
    const control = this.detailsForm.get(controlName);
    return !!control?.errors && (control.dirty || control.touched);
  }

  trackByFn(index: number, item: FilterData): number {
    return item.id;
  }
}
